module.exports = __webpack_public_path__ + "static/img/2.ebff5d60.jpg";